import { readStoredConsent } from './consentStorage';

export function createMetaEventId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}

export function getMetaCookies(): { fbp?: string; fbc?: string } {
  if (typeof document === 'undefined') {
    return {};
  }

  const cookies = document.cookie.split(';').reduce<Record<string, string>>((acc, part) => {
    const [rawKey, ...rest] = part.trim().split('=');
    if (!rawKey) return acc;
    acc[rawKey] = decodeURIComponent(rest.join('='));
    return acc;
  }, {});

  return {
    fbp: cookies._fbp || undefined,
    fbc: cookies._fbc || undefined,
  };
}

export function hasStoredMarketingConsent(): boolean {
  return readStoredConsent()?.marketing === true;
}

export function getMetaEventSourceUrl(): string | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }
  return window.location.href;
}
